import { useAppSelector } from '../../../../../stores/redux.store';
import type { RootState } from '../../../../../stores/redux.store';
import { BasePageState, BaseRedirectState } from '../../../../../utilities/hooks/pageStateTypes';

export type SignupVerifyEmailOtpStateResult = BaseRedirectState | SignupVerifyEmailOtpPageState;

type VerifyEmailOtpSlice = RootState['verifyEmailOtp'];

export type SignupVerifyEmailOtpPageState = BasePageState &
  Pick<VerifyEmailOtpSlice, 'email'> & {
    csrfToken: RootState['csrfToken'];
  };

export const useSignupVerifyEmailOtpState = () => {
  const { email } = useAppSelector(state => state.verifyEmailOtp);
  const csrfToken = useAppSelector(state => state.csrfToken);

  const state: SignupVerifyEmailOtpPageState = {
    type: 'page-state',
    email,
    csrfToken,
  };

  return {
    state,
    isLoading: false,
    isError: false,
    isSuccess: true,
    error: undefined,
  };
};
